import React, { useEffect, useRef, useState } from "react";
import "./Achievements.css";
import scooter from "../../../Image/scootys image/neo/neoteal2.png"; // update path if needed

const achievements = [
  { value: "10K", label: "SCOOTERS SOLD", icon: "🛵" },
  { value: "99%", label: "BEST MATERIALS", icon: "⚙️" },
  { value: "10K", label: "SATISFY CUSTOMERS", icon: "😊" },
  { value: "100%", label: "BEST SERVICES", icon: "🚚" },
];

const Achievements = () => {
  const sectionRef = useRef(null);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimate(true);
          observer.disconnect(); // animation only once
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <section
      className={`achievements ${animate ? "show" : ""}`}
      ref={sectionRef}
    >
      {/* Top Wave */}
      <svg
        className="wave top"
        viewBox="0 0 1440 120"
        preserveAspectRatio="none"
      >
        <path fill="white" d="M0,40 C360,120 1080,0 1440,40 L1440,0 L0,0 Z" />
      </svg>

      <div className="achievements_inner_container">
        {/* Heading */}
        <div className="heading animate-heading">
          <span className="small-title">⚡ KNOW US</span>
          <h2>Our Achievements</h2>
        </div>

        {/* Cards */}
        <div className="cards">
          {achievements.map((item, index) => (
            <div
              className="card animate-card"
              style={{ transitionDelay: `${index * 0.15}s` }}
              key={index}
            >
              <div className="icon-circle">{item.icon}</div>
              <h3>{item.value}</h3>
              <p>{item.label}</p>
            </div>
          ))}
        </div>

        {/* Bottom Section */}
        <div className="bottom">
          {/* Left Info */}
          <div className="info animate-left">
            <div className="block">
              <h4>Our Vision</h4>
              <span className="line"></span>
              <p>
                To transform lives through safe, sustainable, and innovative
                electric mobility solutions.
              </p>
            </div>

            <div className="block">
              <h4>Buyer Protection</h4>
              <span className="line"></span>
              <p>Secure transactions with full buyer protection and trust.</p>
            </div>

            <div className="block">
              <h4>24 Hour Support</h4>
              <span className="line"></span>
              <p>Our experts are available 24/7 to assist you anytime.</p>
            </div>
          </div>

          {/* Center Image */}
          <div className="image animate-image">
            <img src={scooter} alt="Scooter" />
          </div>

          {/* Right Info */}
          <div className="info animate-right">
            <div className="block">
              <h4>Our Mission</h4>
              <span className="line"></span>
              <p>
                Revolutionizing urban mobility with eco-friendly innovation.
              </p>
            </div>

            <div className="block">
              <h4>20% Extra Offer</h4>
              <span className="line"></span>
              <p>Enjoy exclusive discounts on selected scooters.</p>
            </div>

            <div className="block">
              <h4>No Cost EMI</h4>
              <span className="line"></span>
              <p>Easy EMI options with zero extra charges.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Wave */}
      <svg
        className="wave bottom"
        viewBox="0 0 1440 120"
        preserveAspectRatio="none"
      >
        <path
          fill="white"
          d="M0,40 C360,0 1080,80 1440,40 L1440,120 L0,120 Z"
        />
      </svg>
    </section>
  );
};

export default Achievements;
